var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { Close } from 'pcln-icons';
import { IconButton } from '../IconButton';
var propTypes = {
    onClick: PropTypes.func,
    size: PropTypes.number,
    title: PropTypes.string,
};
var CloseButton = function (props) { return (React.createElement(IconButton, __assign({}, props, { icon: React.createElement(Close, { size: props.size }) }))); };
CloseButton.defaultProps = {
    size: 24,
    title: 'close',
};
CloseButton.propTypes = {};
CloseButton.displayName = 'CloseButton';
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map